import BCheckBox from "./BCheckBox";
import BRadioButton from "./BRadioButton";
import BFileField from "./BFileField";
import BTextField from "./BTextField";
import BCTextField from "./BCTextField";
import BInputGroupField from "./BInputGroupField";
import BInputGroupSelectField from "./BInputGroupSelectField";
import BInputGroupSelectField2 from "./BInputGroupSelectField2";
import BTextArea from "./BTextArea";
import BSelectField from "./BSelectField";
import BCSelectField from "./BCSelectField";
import BCSelectAccountNumberField from "./BCSelectAccountNumberField";
import BCSelectField2 from "./BCSelectField2";
import BCSelectFieldOpt from "./BCSelectFieldOpt";
import BCSelectFieldManual from "./BCSelectFieldManual";
import BMultiSelectField from "./BMultiSelectField";
import BCMultiSelectField from "./BCMultiSelectField";
import BCheckBorderedBox from "./BCheckBorderedBox";
import BCheckBorderedBoxManual from "./BCheckBorderedBoxManual";
import MCheckBox from "./MCheckBox";
import MCheckBoxManual from "./MCheckBoxManual";
import MRadioButton from "./MRadioButton";
import MDatePickerField from "./MDatePickerField";
import MTimePickerField from "./MTimePickerField";
import SelectDateTime from "./SelectDateTime";
import SelectDatePicker from "./SelectDatePicker";
import NumberField from "./NumberField"
import CardExpiryField from "./CardExpiryField"
import CardNumberField from "./CardNumberField";

const FormField = {
    BCheckBox,
    BRadioButton,
    BFileField,
    BMultiSelectField,
    BCMultiSelectField,
    BTextField,
    BInputGroupField,
    BInputGroupSelectField,
    BInputGroupSelectField2,
    BCTextField,
    BTextArea,
    BSelectField,
    BCSelectField,
    BCSelectField2,
    BCSelectAccountNumberField,
    BCSelectFieldOpt,
    BCSelectFieldManual,
    BCheckBorderedBox,
    BCheckBorderedBoxManual,
    MDatePickerField,
    MTimePickerField,
    MCheckBox,
    MCheckBoxManual,
    MRadioButton,
    SelectDateTime,
    SelectDatePicker,
    NumberField,
    CardExpiryField,
    CardNumberField
};

export default FormField;
